import React, { Component } from 'react';
import CheckboxSection from "./CheckboxSection";

const ConfiguracionContraseniaDetallada = (props) => {
    return (
        <div>

            <div className="col-md-8">
                <div className="">
                    {props.permiteLetrasConsecutivas ? (

                        <div className="text-configuration-view">
                            <p className="end">Alfabético:  </p>
                            <p className="begin">de forma consecutiva</p>
                        </div>) : (
                        
                        <div className="text-configuration-view">
                                <p className="end">Alfabético:  </p>
                                <p className="begin">en toda la contraseña</p>
                        </div>)}                 
                </div>
            </div>
         

            <div className="col-md-8">
                <div className="">
                    {props.permiteNrosConsecutivos ? (

                        <div className="text-configuration-view">
                            <p className="end">Numérico:  </p>
                            <p className="begin">de forma consecutiva</p>
                        </div>) : (

                        <div className="text-configuration-view">
                                <p className="end">Numérico:  </p>
                                <p className="begin">en toda la contraseña</p>
                        </div>)}
                </div>
            </div>

        </div>
    );
};

export default ConfiguracionContraseniaDetallada;